import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const ScormViewer = () => {
  const { id } = useParams();

  useEffect(() => {
    // Exponer una API SCORM 1.2 mínima para que el contenido dentro del iframe pueda comunicarse
    if (!window.API) {
      const sendProgress = async (payload) => {
        try {
          const API_BASE = process.env.REACT_APP_API_BASE || '';
          const token = sessionStorage.getItem('accessToken');
          await fetch(`${API_BASE}/scorm/track`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ scormId: id, data: payload })
          });
        } catch (err) {
          console.error('Error sending SCORM progress', err);
        }
      };

      window.API = {
        LMSInitialize: function() { console.log('SCORM: LMSInitialize'); return "true"; },
        LMSFinish: function() { console.log('SCORM: LMSFinish');
          // Enviar commit final y marcar como finished
          try {
            const stored = {};
            for (let i = 0; i < localStorage.length; i++) {
              const key = localStorage.key(i);
              if (key && key.startsWith(`scorm_${id}_`)) {
                const shortKey = key.replace(`scorm_${id}_`, '');
                stored[shortKey] = localStorage.getItem(key);
              }
            }
            stored.finished = true;
            sendProgress(stored);
          } catch (e) { console.error(e); }
          return "true";
        },
        LMSGetValue: function(key) { console.log('SCORM: LMSGetValue', key); return localStorage.getItem(`scorm_${id}_${key}`) || ""; },
        LMSSetValue: function(key, value) { console.log('SCORM: LMSSetValue', key, value); localStorage.setItem(`scorm_${id}_${key}`, value); return "true"; },
        LMSCommit: function() { console.log('SCORM: LMSCommit');
          try {
            const stored = {};
            for (let i = 0; i < localStorage.length; i++) {
              const key = localStorage.key(i);
              if (key && key.startsWith(`scorm_${id}_`)) {
                const shortKey = key.replace(`scorm_${id}_`, '');
                stored[shortKey] = localStorage.getItem(key);
              }
            }
            sendProgress(stored);
          } catch (e) { console.error(e); }
          return "true";
        },
        LMSGetLastError: function() { return "0"; },
        LMSGetErrorString: function(code) { return "No error"; },
        LMSGetDiagnostic: function(code) { return ""; }
      };
      console.log('SCORM API stub injected on window.API');
    }

    // Mensajes desde iframe (opcional)
    const handler = (e) => {
      try {
        const msg = e.data;
        if (msg && msg.type === 'scorm-complete') {
          console.log('SCORM completed:', msg);
          // Aquí podríamos notificar al backend sobre la finalización
        }
      } catch (err) {
        // ignore
      }
    };

    window.addEventListener('message', handler);
    return () => window.removeEventListener('message', handler);
  }, [id]);

  const launchUrl = `${process.env.REACT_APP_API_BASE || ''}/scorm/launch/${id}`;

  return (
    <div style={{ width: '100%', height: '100vh', background: '#000' }}>
      <iframe
        title={`scorm-${id}`}
        src={launchUrl}
        style={{ width: '100%', height: '100%', border: 'none' }}
        sandbox="allow-scripts allow-same-origin allow-forms"
      />
    </div>
  );
};

export default ScormViewer;
